import { client } from "./axiosClient";

/**
 * Service layer dos endpoints v2 de gestao de permissoes (Fase 3).
 * Consome /api/v2/* criados em api/views/access.py.
 */

// --- Catalogo & presets (read-only) ---

export async function getPermissionsCatalog() {
  const response = await client.get("api/v2/permissions/catalog/");
  return response.data;
}

export async function getPresets() {
  const response = await client.get("api/v2/presets/");
  return response.data;
}

// --- Usuarios ---

export async function getUsers() {
  const response = await client.get("api/v2/users/");
  return response.data;
}

export async function updateUserPermissions(userId, permissions) {
  const response = await client.patch(`api/v2/users/${userId}/permissions/`, {
    permissions,
  });
  return response.data;
}

export async function applyPreset(userId, presetCode) {
  const response = await client.post(`api/v2/users/${userId}/apply_preset/`, {
    preset_code: presetCode,
  });
  return response.data;
}

export async function copyPermissionsFrom(userId, sourceUserId) {
  const response = await client.post(`api/v2/users/${userId}/copy_from/`, {
    source_user_id: sourceUserId,
  });
  return response.data;
}

export async function updateUserScope(userId, filters) {
  const response = await client.patch(`api/v2/users/${userId}/scope/`, {
    filters,
  });
  return response.data;
}

// --- Bulk ---

export async function bulkApplyPreset(userIds, presetCode) {
  const response = await client.post("api/v2/users/bulk/", {
    action: "apply_preset",
    user_ids: userIds,
    preset_code: presetCode,
  });
  return response.data;
}

export async function bulkApplyScope(userIds, filters) {
  const response = await client.post("api/v2/users/bulk/", {
    action: "apply_scope",
    user_ids: userIds,
    filters,
  });
  return response.data;
}

// Persiste varias edicoes acumuladas (tabela) numa unica transacao.
export async function bulkSave(changes) {
  const response = await client.post("api/v2/users/bulk_save/", { changes });
  return response.data;
}

// --- Audit log ---

export async function getAuditLog({
  targetUserId,
  action,
  limit,
  offset,
} = {}) {
  const params = {};
  if (targetUserId) params.target_user_id = targetUserId;
  if (action) params.action = action;
  if (limit != null) params.limit = limit;
  if (offset != null) params.offset = offset;
  const response = await client.get("api/v2/users/audit/", { params });
  return response.data;
}
